import React from "react";
import PageRouting from "./components/common/PageRouting"; // Adjust the path according to your project structure
import { BrowserRouter as Router } from 'react-router-dom';
function App() {
  return (
    <Router>
    <PageRouting />
  </Router>
  );
}

export default App;
